import { render } from "./PricesTable.vue?vue&type=template&id=3c32be68&scoped=true"
import script from "./PricesTable.vue?vue&type=script&lang=js"
export * from "./PricesTable.vue?vue&type=script&lang=js"

import "./PricesTable.vue?vue&type=style&index=0&id=3c32be68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c32be68"]])

export default __exports__